import React from 'react'
import PropTypes from 'prop-types'
import { observer } from 'mobx-react'
import { Field, FieldArray } from 'formik'
import { Autocomplete } from '@components/Form/Autocomplete'
import RepeatableAction from '@components/Form/RepeatableAction'
import get from 'lodash/get'

const ContractCoverageItems = ({
  contract,
  form,
  name,
  autocompleteProps,
  repeatableActionProps
}) => {
  let items = get(form.values, name)
  items = items.length ? items : [repeatableActionProps.initialObject]

  return (
    <div className='expert-form__input-group'>
      <label className='expert-form__label' />
      <div className='expert-form__input-wrapper'>
        <FieldArray
          name={name}
          render={arrayHelpers => (
            <div className='expert-form__repeatable-input-wrapper'>
              {items.map((item, index) => {
                const disabled = contract && index < contract[name].length
                return (
                  <div className='expert-form__repeatable-input' key={index}>
                    <Field
                      disabled={disabled}
                      name={`${name}[${index}]`}
                      placeholder='Search...'
                      component={Autocomplete}
                      value={items[index]}
                      {...autocompleteProps}
                    />
                    <RepeatableAction
                      fieldValues={items}
                      allowDelete={!disabled}
                      disabled={disabled}
                      arrayHelpers={arrayHelpers}
                      index={index}
                      {...repeatableActionProps}
                    />
                  </div>
                )
              })}
            </div>
          )}
        />
      </div>
    </div>
  )
}

ContractCoverageItems.propTypes = {
  contract: PropTypes.object,
  form: PropTypes.object,
  name: PropTypes.string,
  autocompleteProps: PropTypes.object,
  repeatableActionProps: PropTypes.object
}

export default observer(ContractCoverageItems)
